/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface IncustControllersClientClientPaymentWalletCardPassword200ResponseApiModel {
  /**
   * Operation status
   */
  status?: IncustControllersClientClientPaymentWalletCardPassword200ResponseApiModelStatusEnum;
}
export enum IncustControllersClientClientPaymentWalletCardPassword200ResponseApiModelStatusEnum {
  Success = 'success',
  Fail = 'fail'
}
